import { Injectable } from '@angular/core';
import {User} from './models/users.model';
import {Lab} from './models/labs.model';
import {Observable} from 'rxjs/Observable';
const apigClientFactory = require('./apigClient/apigClient.js').default;

@Injectable()
export class UserService {

  public fullname = '';
  public user:User = new User();
  public cognitoAccessKey = '';
  public cognitoSecretKey = '';
  public cognitoSessionToken = '';
  public URL = 'https://n0qdznfrlk.execute-api.us-east-1.amazonaws.com/dev';
  constructor(){
  }

  public createUser(user: User): Observable<User> {

    const apigClient = apigClientFactory.newClient({
      accessKey: this.cognitoAccessKey,
      secretKey: this.cognitoSecretKey,
      sessionToken: this.cognitoSessionToken,
      invokeUrl: this.URL
    });

    console.log(apigClient);

    const observable = new Observable<User>(observer => {
      apigClient.invokeApi({}, '/labs/lab1', 'POST', {}, JSON.parse(JSON.stringify(user)))
        .then(function (userData) {
          console.log("USERDATA OBJ: ", userData);
          console.log("Data var: ", userData.data);
          //let data = JSON.parse(userData.data);
          let data = userData.data;
          observer.next(data);
          observer.complete();
          console.log(userData);
        }).catch(function (meError) {
        console.log(meError);
        observer.error(meError);
        console.log(meError);
      });
    });
    return observable;
  }

  public verifyLab2(security_group: string): Observable<User> {

    let sec_ob = {
      "securityGroupID":security_group
    }

    const apigClient = apigClientFactory.newClient({
      accessKey: this.cognitoAccessKey,
      secretKey: this.cognitoSecretKey,
      sessionToken: this.cognitoSessionToken,
      invokeUrl: this.URL
    });

    const observable = new Observable<User>(observer => {
      apigClient.invokeApi({}, '/labs/lab2', 'POST', {}, JSON.parse(JSON.stringify(sec_ob)))
        .then(function (userData) {
          console.log("USERDATA OBJ: ", userData);
          console.log("Data var: ", userData.data);
          //let data = JSON.parse(userData.data);
          let data = userData.data;
          observer.next(data);
          observer.complete();
          console.log(userData);
        }).catch(function (meError) {
        console.log(meError);
        observer.error(meError);
        console.log(meError);
      });
    });
    return observable;
  }

  // public getLabStatus(user: User): Observable<User> {
  //
  //   const apigClient = apigClientFactory.newClient({
  //     accessKey: this.cognitoAccessKey,
  //     secretKey: this.cognitoSecretKey,
  //     sessionToken: this.cognitoSessionToken,
  //     invokeUrl: this.URL
  //   });
  //
  //   console.log(apigClient);
  //
  //   const observable = new Observable<Lab[]>(observer => {
  //     apigClient.invokeApi({}, '/labs/labs', 'GET', {})
  //       .then(function (labData) {
  //         let data = labData.data;
  //         observer.next(data);
  //         observer.complete();
  //       }).catch(function (meError) {
  //       console.log(meError);
  //       observer.error(meError);
  //       console.log(meError);
  //     });
  //   });
  //   return observable;
  // }
}



// WEBPACK FOOTER //
// ./src/app/user.service.ts